module.exports = __webpack_public_path__ + "static/media/Drone.6cac2621.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/png-images/Drone.png
// module id = 3032
// module chunks = 0